module.exports = __webpack_public_path__ + "img/vignettes-asso_0009_petit-palais.5e17785e.jpg";